import { Controller } from "@hotwired/stimulus"
import { Turbo } from "@hotwired/turbo-rails"

export default class extends Controller {
  static targets = ["filtersPopover"]

  static values = {
    url: String,
    selectedFilters: { type: Array, default: [] }
  }

  connect() {
    this.syncFiltersTrigger()
  }

  applyFilters(event) {
    this.selectedFiltersValue = event.detail.values
    this.syncFiltersTrigger()
    this.refresh()
  }

  itemChanged() {
    this.refresh()
  }

  syncFiltersTrigger() {
    if (!this.hasFiltersPopoverTarget) return

    const trigger = this.filtersPopoverTarget.querySelector(".filter-popover-trigger")
    if (!trigger) return

    const active = this.selectedFiltersValue.length > 0
    trigger.classList.toggle("purple-soft-btn", active)
    trigger.classList.toggle("purple-outline-btn", !active)

    let badge = trigger.querySelector(".filter-count-badge")
    if (active) {
      if (!badge) {
        badge = document.createElement("span")
        badge.className = "filter-count-badge"
        trigger.appendChild(badge)
      }
      badge.textContent = this.selectedFiltersValue.length
    } else if (badge) {
      badge.remove()
    }
  }

  async refresh() {
    if (!this.hasUrlValue) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.delete("filters[]")
    this.selectedFiltersValue.forEach((filter) => url.searchParams.append("filters[]", filter))

    try {
      const response = await fetch(url, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
          "X-CSRF-Token": this.csrfToken
        },
        credentials: "same-origin"
      })

      if (!response.ok) return

      Turbo.renderStreamMessage(await response.text())
      this.syncFiltersTrigger()
    } catch (error) {
      console.error("Failed to load bookmarked content:", error)
    }
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
